import { api } from 'common';

import { SkillV2Documentation } from './Documentation';
import { SkillV2BlockFormFields } from './FormFields';
import type { BlockConfigProps } from '../../../types';
import { getSubFlowBlockDefaultConfig } from '../../SubFlow/v2/constants';

export const skillV2Config: BlockConfigProps<api.FlowDefinition.SkillV2BlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'skill',
  defaultConfig: getSubFlowBlockDefaultConfig(),
  configFields: {
    schema: api.FlowDefinition.SkillV2BlockConfigSchema,
    FormFields: SkillV2BlockFormFields,
  },
  documentationMarkdown: SkillV2Documentation,
};
